import { render, staticRenderFns } from "./DIS_features_module_three.vue?vue&type=template&id=650beeb5&"
import script from "./DIS_features_module_three.vue?vue&type=script&lang=js&"
export * from "./DIS_features_module_three.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports